import { useState, useEffect } from "react";
import { MdOutlineExitToApp } from "react-icons/md";
import { CardCustom, Header } from "../../components";
import { logoutRequest } from "../../actions";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { encrypt } from "../../utils/crypt";
import log_eval from "../../assets/img/logo_eval.png";
import Swal from "sweetalert2";
import axios from "../../api";
import { Grid, makeStyles, Box, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/**
 * Endpoints Involucrados:
 * 1. POST /period/getPeriods - Obtiene los periodos académicos.
 * 2. GET /evaluations/getTeachersxClass/:userId - Obtiene materias, docentes y registros de evaluación.
 * 3. POST /evaluations/salveEvaluation - Crea o recupera un registro de evaluación al iniciar.
 * 4. POST /evaluations/getQuestions - Obtiene las preguntas de la encuesta.
 * 5. POST /evaluations/salveEvaluationDetail - Guarda las respuestas de una sección.
 * 6. POST /evaluations/endEvaluation - Marca la evaluación como finalizada.
 */
const SelectTeacher = (props) => {
  const classes = useStyles();
  const {
    user = {
      id: 0,
      nombres: "",
      apellidos: "",
    },
    token = "",
    userId = 1,
    logoutRequest,
  } = props;

  const [listTeachers, setListTeachers] = useState([]);
  const [date, setDate] = useState(new Date());
  const [loading, setLoading] = useState(true);
  const history = useNavigate();

  const formatDate = (date = new Date()) => {
    let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
    let month =
      date.getMonth() + 1 < 10
        ? `0${date.getMonth() + 1}`
        : date.getMonth() + 1;
    let year = date.getFullYear();
    let hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
    let minutes =
      date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    let seconds =
      date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (token.trim().length > 0) {
      getPeriodo();
    } else {
      history("/");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getPeriodo = () => {
    try {
      axios
        .post(
          "/period/getPeriods",
          {
            estado: 1,
          },
          {
            headers: {
              "access-token": token,
            },
          },
        )
        .then(({ data }) => {
          const { periods, message } = data;
          // console.log("Periodos recibidos:", periods);
          if (periods.length > 0) {
            // Fix: Find the maximum end date from active periods rather than assuming the last element
            const validDates = periods.map((p) =>
              new Date(p.fecha_fin).getTime(),
            );
            const limitPeriod = new Date(Math.max(...validDates));
            // Comentamos o eliminamos el bloqueo global para permitir postgrados y múltiples periodos
            /*
            if (limitPeriod < new Date()) {
              Swal.fire({
                icon: "error",
                text: "El periodo de evaluación no se encuentra activo.",
                showConfirmButton: true,
                confirmButtonColor: "rgb(157, 16, 4)",
              }).then(() => {
                logoutRequest();
                history("/");
              });
            } else {
              setDate(limitPeriod);
              getTeachersxClass();
            }
            */
            setDate(limitPeriod);
            getTeachersxClass();
          } else {
            // Si no hay periodos, aún así intentamos cargar las materias por si acaso (postgrado continuo)
            getTeachersxClass();
          }
        })
        .catch((err) => {
          console.error("Error al obtener periodos:", err);
          getTeachersxClass(); // Intentamos cargar materias aunque falle el global
        });
    } catch (error) {
      console.error(error);
      getTeachersxClass();
    }
  };

  const getTeachersxClass = () => {
    try {
      axios
        .get("/evaluations/getTeachersxClass/" + userId, {
          headers: { "access-token": token },
        })
        .then((result) => {
          // console.log("Respuesta Completa listTeachers:", result.data);
          const { group = [], evaluations = [] } =
            result.data.listTeachers || {};

          if (group.length > 0) {
            const listItem = [];
            group.map((item) => {
              // El backend ahora envía el periodo dentro de cada materia/grupo
              const periodoMateria = item.periodo || item.grupoMateria?.periodo;

              // NUEVA VALIDACIÓN: Solo mostrar evaluaciones del periodo que esté activo (estado 1)
              if (periodoMateria && periodoMateria.estado !== 1) return;

              const endDate = periodoMateria?.fecha_fin
                ? new Date(periodoMateria.fecha_fin.replace(" ", "T"))
                : null;
              const now = new Date();

              item.grupoMateria.docentes.map((item2) => {
                const foundEval = evaluations.find(
                  (item3) =>
                    item3.id_grupo_materias_evaluado === item.grupoMateria.id &&
                    item3.id_usuario_evaluado === item2.usuario.id &&
                    item3.id_periodos === item.id_periodos,
                );

                if (item2.id_periodos !== item.id_periodos && !foundEval)
                  return; // Strict period isolation BUT preserve already evaluated records

                // console.log(
                //   `--- Procesando Docente: ${item2.usuario.nombres} ---`,
                // );
                // console.log("Evaluación encontrada en listado:", foundEval);
                // if (foundEval) {
                //   console.log("ID Evaluación:", foundEval.id);
                //   console.log("Estado (vp_estado):", foundEval.vp_estado);
                // } else {
                //   console.log(
                //     "No se encontró evaluación previa para este docente en este grupo.",
                //   );
                // }

                // El backend puede enviar diferentes indicadores según la tabla de tu DB
                let finalState = 324; // Sin iniciar por defecto
                if (foundEval) {
                  // Prioridad a campos que confirman finalización (estado 2, vp_estado 323 o fecha_final presente)
                  if (foundEval.estado === 2 || foundEval.vp_estado === 323 || foundEval.fecha_final) {
                    finalState = 323; // Terminado
                  } else {
                    finalState = 322; // Iniciado pero no terminado (En Curso)
                  }
                }

                // Si el periodo expiró y no lo ha terminado, lo marcamos como expirado (999) visualmente
                if (endDate && now > endDate && finalState !== 323) {
                  finalState = 999;
                }

                // NUEVA CONDICIÓN: Solo mostramos evaluaciones pendientes (324 o 322)
                // Ocultamos las finalizadas (323) y las expiradas (999)
                if (finalState === 323 || finalState === 999) return;

                const evaluation = foundEval || {
                  vp_estado: finalState,
                  id: null,
                };

                listItem.push({
                  nombres: item2.usuario.nombres,
                  apellidos: item2.usuario.apellidos,
                  materia: item.grupoMateria.nombre,
                  idEvaluacion: evaluation.id,
                  estado: finalState, // Usamos el estado ya normalizado
                  idDocente: item2.usuario.id,
                  idEstudiante: item.usuario.id,
                  idMaterias: item.grupoMateria.id_materias,
                  idPeriodo: item.id_periodos,
                  idGrupoEstudiantesMaterias: item.id,
                  idGrupoMateria: item.grupoMateria.id,
                  idPrograma: item.grupoMateria.materias?.programa?.id,
                  // Fallbacks robustos para modalidad y nivel académico
                  modalidad:
                    item.modalidad ||
                    item.grupoMateria.modalidad ||
                    item.grupoMateria.materias?.modalidad ||
                    item.grupoMateria.materias?.programa?.modalidad ||
                    (item.grupoMateria.nombre.toUpperCase().includes("POST") ||
                    item.grupoMateria.nombre.toUpperCase().includes("MAESTR") ||
                    item.grupoMateria.nombre.toUpperCase().includes("ESP")
                      ? "POSTGRADO"
                      : "PREGRADO"),
                  nivel_academico:
                    item.nivel_academico ||
                    item.grupoMateria.nivel_academico ||
                    item.grupoMateria.materias?.nivel_academico ||
                    item.grupoMateria.materias?.programa?.nivel_academico ||
                    1,
                  // Guardamos el periodo específico de esta materia
                  fechaFinMateria: periodoMateria?.fecha_fin,
                  nombrePeriodo: periodoMateria?.nombre,
                });
              });
            });
            setListTeachers(listItem);
          } else {
            setListTeachers([]);
          }
        })
        .catch((error) => {
          console.error("Error en getTeachersxClass:", error);
          Swal.fire({
            icon: "error",
            text: "Error al consultar las clases.",
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (error) {
      console.error(error);
      setLoading(false);
    }
  };

  const selectingTeacher = (props) => {
    const {
      idDocente,
      idEstudiante,
      idGrupoMateria,
      idMaterias,
      idPeriodo,
      idEvaluacion,
      idPrograma,
      estado,
    } = props;
    try {
      if (estado === 999) {
        Swal.fire({
          icon: "info",
          text: "El tiempo para evaluar a este docente ha finalizado.",
          showConfirmButton: false,
          timer: 2000,
        });
        return;
      }
      if (estado !== 323) {
        const data = {
          idDocente,
          idEstudiante,
          idGrupoMateria,
          idMaterias,
          idPeriodo,
          idPrograma,
          fechaInicio: new Date(),
        };
        axios
          .post(
            "evaluations/salveEvaluation",
            { data },
            {
              headers: { "access-token": token },
            },
          )
          .then(({ data }) => {
            const result = data.respuesta.id;
            history(`/selectingTeacher/${encrypt(result)}`);
          });
      }
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <div
      style={{
        backgroundColor: "#f8fafc",
        height: "100%",
        minHeight: "100vh",
      }}
      className="pt-8 p-4 sm:p-6"
    >
      <div
        className="container"
        style={{ maxWidth: "1200px", margin: "0 auto" }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          mb={4}
        >
          <Header
            category="Evaluación de Docente"
            title="Selección de docente"
          />
          <button
            className="btn shadow-sm"
            title="Cerrar sesión"
            style={{
              borderRadius: "15px",
              backgroundColor: "white",
              padding: "12px",
              border: "none",
              color: "#9d2d39",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              transition: "all 0.3s ease",
            }}
            onClick={() => {
              logoutRequest();
              history("/");
            }}
          >
            <MdOutlineExitToApp size={28} />
          </button>
        </Box>

        <div className="mb-8">
          <Box display="flex" flexDirection="column" gridGap={4}>
            <Typography
              variant="h6"
              style={{ fontWeight: 800, color: "#1e293b" }}
            >
              Hola,{" "}
              <span style={{ color: "#9d2d39" }}>
                {user.nombres} {user.apellidos}
              </span>
            </Typography>
            {date.getFullYear() <= 2026 && (
              <Box display="flex" alignItems="center" gridGap={8}>
                <Typography
                  variant="body2"
                  style={{ color: "#64748b", fontWeight: 600 }}
                >
                  FECHA LÍMITE DEL PERIODO:
                </Typography>
                <Typography
                  variant="body2"
                  style={{ color: "#0f172a", fontWeight: 800 }}
                >
                  {formatDate(date)}
                </Typography>
              </Box>
            )}
          </Box>
        </div>
        <Grid container spacing={2}>
          {loading ? (
            <Grid container spacing={2}>
              {[1, 2, 3, 4, 5, 6].map((i) => (
                <Grid item xs={12} sm={6} md={4} key={i}>
                  <Skeleton
                    variant="rect"
                    width="100%"
                    height={180}
                    style={{ borderRadius: "25px", marginBottom: "10px" }}
                    animation="pulse"
                  />
                  <Box
                    display="flex"
                    flexDirection="column"
                    gridGap={10}
                    mt={1}
                    px={1}
                  >
                    <Skeleton variant="text" width="60%" height={30} />
                    <Skeleton variant="text" width="40%" height={20} />
                  </Box>
                </Grid>
              ))}
            </Grid>
          ) : listTeachers.length === 0 ? (
            <Grid item xs={12}>
              <div
                className="text-center mt-5 mb-5 p-5 bg-white shadow-sm"
                style={{ borderRadius: "20px" }}
              >
                <div className="d-flex justify-content-center">
                  <img
                    src="https://cdn-icons-png.flaticon.com/512/10473/10473461.png"
                    alt="Todo al día"
                    style={{
                      width: "120px",
                      opacity: 0.8,
                      marginBottom: "20px",
                      alignSelf: "center",
                    }}
                  />
                </div>
                <h3 style={{ fontWeight: 800, color: "#334155" }}>
                  ¡Estás al día!
                </h3>
                <p
                  style={{
                    color: "#64748b",
                    margin: "10px auto",
                    maxWidth: "500px",
                  }}
                >
                  No tienes docentes pendientes por evaluar en este momento.
                  Agradecemos enormemente tu participación en los procesos
                  pasados. Sus opiniones nos ayudan a mejorar continuamente.
                </p>
              </div>
            </Grid>
          ) : (
            listTeachers.map((item, index) => (
              <div className={classes.card} key={index}>
                <CardCustom
                  title={item.materia}
                  details={`Profesor: ${item.nombres} ${item.apellidos ?? ""}`}
                  estado={item.estado}
                  deadline={item.fechaFinMateria}
                  periodName={item.nombrePeriodo}
                  modalidad={item.modalidad}
                  onClick={() => {
                    selectingTeacher(item);
                  }}
                />
              </div>
            ))
          )}
        </Grid>
      </div>
      <footer
        className="col-12 w-100"
        style={{
          backgroundColor: "#9d2d39",
          marginTop: "10vh",
          padding: "40px 0",
          textAlign: "center",
        }}
      >
        <img
          src={log_eval}
          alt="Logo Evaluación Docente"
          style={{ height: "60px", opacity: 0.9 }}
        />
      </footer>
    </div>
  );
};

const useStyles = makeStyles((theme) => ({
  card: {
    margin: "5px 10px 5px 10px",
    width: "30%",
    [theme.breakpoints.down(700)]: {
      margin: "0 0 8px 0",
      width: "100%",
    },
  },
}));

const mapStateToProps = (state) => {
  return {
    user: state.user,
    userId: state.user.id,
    token: state.token,
    permission: (state.permission || [])
      .filter((data) => data.modulosAcciones?.id_modulos === 10)
      .map((item) => item.modulosAcciones?.id_acciones),
  };
};

const mapDispatchToprops = {
  logoutRequest,
};

export default connect(mapStateToProps, mapDispatchToprops)(SelectTeacher);
